/**
 * Migration v3 / Offline Support / Init
 * Originally lines 10191-11148 of monolithic index.html.
 * Phase 2 modularization, Sprint 2 (2026-05-07).
 */

        // Sprint 24: i18n helper — fallback to RU string when key not loaded yet.
        // window.i18n is set by /public/js/i18n/index.js (auto-init on import).
        const _t = (k, fb) => {
            const v = (window.i18n && typeof window.i18n.t === 'function') ? window.i18n.t(k) : null;
            return (v && v !== k) ? v : (fb || k);
        };

        // ===== Migration v3: Offline Support Classes =====

        /**
         * OfflineManager - Handles offline/online state and operation queuing
         */
        class OfflineManager {
            constructor(apiClient) {
                this.apiClient = apiClient;
                this.queue = [];
                this.isOnline = navigator.onLine;

                window.addEventListener('online', () => this.handleOnline());
                window.addEventListener('offline', () => this.handleOffline());
            }

            handleOffline() {
                this.isOnline = false;
                this.showNotification(_t('bootstrap.offline.went_offline', 'Работа в оффлайн режиме. Изменения будут синхронизированы позже.'), false);
            }

            async handleOnline() {
                this.isOnline = true;
                this.showNotification(_t('bootstrap.offline.came_online', 'Соединение восстановлено. Синхронизация...'), false);
                await this.syncQueue();
            }

            async syncQueue() {
                while (this.queue.length > 0) {
                    const operation = this.queue.shift();
                    try {
                        await operation.execute();
                    } catch (error) {
                        this.queue.unshift(operation);  // Re-queue on failure
                        break;
                    }
                }
            }

            queueSave(catalogData) {
                this.queue.push({
                    type: 'save',
                    data: catalogData,
                    timestamp: Date.now(),
                    execute: () => this.apiClient.saveCatalog(catalogData.name, catalogData.data)
                });
            }

            showNotification(message, isError) {
                if (window.QuoteCalc && window.QuoteCalc.showNotification) {
                    window.QuoteCalc.showNotification(message, isError);
                } else {
                    console.log(message);
                }
            }
        }

        /**
         * CatalogCache - In-memory cache with TTL
         */
        class CatalogCache {
            constructor() {
                this.cache = new Map();
                this.ttl = 5 * 60 * 1000;  // 5 minutes
            }

            set(id, data) {
                this.cache.set(id, {
                    data,
                    timestamp: Date.now()
                });
            }

            get(id) {
                const entry = this.cache.get(id);
                if (!entry) return null;

                const age = Date.now() - entry.timestamp;
                if (age > this.ttl) {
                    this.cache.delete(id);
                    return null;
                }

                return entry.data;
            }

            clear() {
                this.cache.clear();
            }
        }

        // ===== End of Offline Support Classes =====

        // Ждём загрузки всех внешних ресурсов (включая Quill из CDN)
        window.addEventListener('load', function() {
            // ============================================================================
            // 🔐 AUTH GUARD - КРИТИЧЕСКИ ВАЖНО (Migration 010)
            // ============================================================================
            // Проверяем наличие JWT токена ПЕРЕД инициализацией калькулятора
            // БЕЗ токена - показываем ТОЛЬКО страницу логина, НЕ калькулятор
            // Это предотвращает несанкционированный доступ к данным организации

            // Sprint 15 C.1 (2026-05-09): auth теперь httpOnly cookies + auth_present hint.
            // JS не имеет доступа к access_token — XSS-resistant.
            const hasAuthHint = document.cookie.split(';').some(
                c => c.trim().indexOf('auth_present=1') === 0
            );

            // Проверяем, что мы НЕ на странице логина
            const isLoginPage = window.location.pathname === '/login' ||
                                window.location.pathname === '/login.html';

            if (!hasAuthHint && !isLoginPage) {
                // ❌ Нет auth cookie и не на login → редирект
                console.warn('[Auth Guard] No auth cookie, redirecting to login...');
                window.location.href = '/login.html';
                return;
            }

            if (!hasAuthHint && isLoginPage) {
                console.log('[Auth Guard] On login page, calculator not initialized');
                return;
            }

            // ✅ Auth cookie есть → инициализируем калькулятор
            console.log('[Auth Guard] auth cookie present, initializing calculator...');

            // ============================================================================
            // Инициализация калькулятора (только если есть токен)
            // ============================================================================

            // 🔗 ESM-readiness: используем window.X для внешних классов, чтобы init.js
            //   мог быть загружен как через classic <script>, так и через ESM import.
            //   Classic-script load: window.X выставлен через global hoist + явное
            //   присваивание в конце соответствующих файлов.
            //   ESM load: window.X выставлен только явным присваиванием (см. apiClient.js,
            //   errorBoundary.js, js/CacheManager.js, js/SyncManager.js, js/APIClientV1.js).

            // Создаем apiClient ПОСЛЕ загрузки apiClient.js
            window.apiClient = new window.APIClient();
            const apiClient = window.apiClient;

            // ВАЖНО: Создаём QuoteCalc ПОСЛЕ apiClient
            const QuoteCalc = new window.ProfessionalQuoteCalculator();
            // ✅ FIX: apiClient устанавливается в QuoteCalc.init() автоматически
            window.QuoteCalc = QuoteCalc;

            // ===== Phase 8c: Multi-currency cache =====
            // Загружаем активные валюты + курсы + комиссии для текущей org.
            // Не блокирующий — async; формулы работают в USD (legacy) до загрузки.
            // Также подписываемся на событие 'currencies-updated' (settings.js)
            // чтобы рефрешнуть при смене настроек валют без перезагрузки страницы.
            if (typeof QuoteCalc._refreshCurrencyCache === 'function') {
                QuoteCalc._refreshCurrencyCache().catch(err => {
                    console.warn('[Currency] initial cache refresh failed (non-fatal):', err.message);
                });
                window.addEventListener('currencies-updated', () => {
                    QuoteCalc._refreshCurrencyCache();
                });
            }

            // ===== ErrorBoundary Integration =====
            // Создаём ErrorBoundary для централизованной обработки ошибок
            const errorBoundary = new window.ErrorBoundary(QuoteCalc);
            window.errorBoundary = errorBoundary;

            console.log('[Init] ErrorBoundary initialized successfully');

            // ===== Migration v3.0 - Sync & Cache Integration =====
            // Создаём CacheManager для управления localStorage
            const cacheManager = new window.CacheManager();
            window.cacheManager = cacheManager;
            console.log('[Init] CacheManager initialized');

            // Создаём SyncManager для синхронизации с сервером
            const syncManager = new window.SyncManager(apiClient, cacheManager);
            window.syncManager = syncManager;

            // Запускаем периодическую синхронизацию (каждые 5 минут)
            syncManager.start();
            console.log('[Init] SyncManager started');

            // ===== Migration v3: Offline Support Integration =====
            const catalogCache = new CatalogCache();
            window.catalogCache = catalogCache;

            const offlineManager = new OfflineManager(apiClient);
            window.offlineManager = offlineManager;

            console.log('[Init] Offline support initialized (cache + queue)');

            // Первая полная синхронизация (асинхронно, не блокируем UI)
            syncManager.performFullSync()
                .then(() => {
                    console.log('[Init] Full sync completed successfully');
                })
                .catch(err => {
                    console.error('[Init] Full sync failed:', err);
                });

            // ===== Migration v3.0 - Auto-load default catalog from server =====
            QuoteCalc.loadDefaultCatalog()
                .then(() => {
                    console.log('[Init] Default catalog loaded successfully');
                })
                .catch(err => {
                    console.warn('[Init] Default catalog load failed:', err);
                });

        // УДАЛЕНО: loadAutosaveFromServer() больше не нужна
        // Теперь автосохранение сохраняет напрямую в текущий файл сметы
        // При перезагрузке страницы пользователь вручную выбирает нужную смету

        // Расширение класса ProfessionalQuoteCalculator для работы с сервером
        (function() {
            const originalInit = QuoteCalc.init.bind(QuoteCalc);

            // Переопределяем метод сохранения каталога
            QuoteCalc.saveCatalogToServer = async function() {
                try {
                    const catalogData = {
                        version: this.CATALOG_VERSION,
                        timestamp: new Date().toISOString(),
                        region: this.currentRegion || 'Default',
                        templates: this.templates,
                        categories: this.categories
                    };
                    await apiClient.saveCatalog(catalogData, 'catalog.json');
                    this.showNotification(_t('bootstrap.catalog.saved', 'Каталог сохранён на сервере'), false);
                } catch (err) {
                    console.error('Error saving catalog:', err);
                    this.showNotification(_t('bootstrap.catalog.save_failed', 'Ошибка сохранения каталога') + ': ' + err.message, true);
                }
            };

            // Переопределяем метод загрузки каталога
            QuoteCalc.loadCatalogFromServer = async function() {
                try {
                    const data = await apiClient.loadCatalog('catalog.json');
                    if (data && data.templates) {
                        this.templates = data.templates;
                        this.categories = data.categories || [];
                        this.currentRegion = data.region || 'Default';
                        this.saveToLocalStorage();
                        this.renderTemplates();
                        this.showNotification(_t('bootstrap.catalog.loaded', 'Каталог загружен с сервера'), false);
                    }
                } catch (err) {
                    console.error('Error loading catalog:', err);
                    this.showNotification(_t('bootstrap.catalog.load_failed', 'Ошибка загрузки каталога') + ': ' + err.message, true);
                }
            };

            // Генерация имени файла из данных клиента
            QuoteCalc.generateFilename = function() {
                // Транслитерация кириллицы в латиницу
                const translitMap = {
                    'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'yo', 'ж': 'zh',
                    'з': 'z', 'и': 'i', 'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o',
                    'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'ts',
                    'ч': 'ch', 'ш': 'sh', 'щ': 'sch', 'ъ': '', 'ы': 'y', 'ь': '', 'э': 'e', 'ю': 'yu', 'я': 'ya'
                };

                const translit = (str) => {
                    return str.toLowerCase().split('').map(char =>
                        translitMap[char] || char
                    ).join('');
                };

                // Формируем имя из: clientName_tourStart_paxCount
                const clientName = translit(this.state.clientName || 'Unnamed').replace(/[^a-z0-9]/g, '_');
                const tourStart = this.state.tourStart || new Date().toISOString().split('T')[0];
                const paxCount = this.state.paxCount || 0;

                return `${clientName}_${tourStart}_${paxCount}pax.json`;
            };

            // Сохранение сметы на сервер.
            // 🆕 Group 3: showNotification по умолчанию false — тихие сохранения.
            //   Caller'ы которые хотят показать toast явно передают `true`.
            QuoteCalc.saveQuoteToServer = async function(filename, showNotification = false) {
                try {
                    // Получаем актуальные значения из DOM
                    const programDescField = document.getElementById('program-description');
                    const quoteCommentsField = document.getElementById('quote-description');

                    // Обновляем state перед сохранением
                    if (programDescField) this.state.programDescription = programDescField.value;
                    if (quoteCommentsField) this.state.quoteComments = quoteCommentsField.value;

                    // Если нет ID, создаём новую смету с ID
                    if (!this.state.currentQuoteId) {
                        this.state.currentQuoteId = this.generateQuoteId();
                    }

                    // Генерируем имя файла с ID
                    const newFilename = this.generateFilenameWithId({
                        id: this.state.currentQuoteId,
                        clientName: this.state.clientName,
                        tourStart: this.state.tourStart,
                        paxCount: this.state.paxCount
                    });

                    const quoteData = {
                        id: this.state.currentQuoteId,  // Добавляем ID
                        version: this.QUOTE_VERSION,
                        timestamp: new Date().toISOString(),
                        clientId: this.state.clientId || null,    // Sprint 18: FK к clients.id
                        tourName: this.state.tourName || null,    // Sprint 18: user-friendly имя
                        clientId: this.state.clientId || null,
                        tourName: this.state.tourName || null,
                        clientName: this.state.clientName,
                        clientPhone: this.state.clientPhone,
                        clientEmail: this.state.clientEmail,
                        paxCount: this.state.paxCount,
                        tourStart: this.state.tourStart,
                        tourEnd: this.state.tourEnd,
                        services: this.state.services,
                        hotels: this.state.hotels || [],
                        flights: this.state.flights || [],
                        otherServices: this.state.otherServices || [],
                        hiddenMarkup: this.state.hiddenMarkup,
                        taxRate: this.state.taxRate,
                        programDescription: this.state.programDescription,
                        quoteComments: this.state.quoteComments
                    };

                    // Если был старый файл с другим именем, переименовываем
                    if (this.state.currentQuoteFile && this.state.currentQuoteFile !== newFilename) {
                        try {
                            // ✅ FIX: Используем currentQuoteId (UUID), а не currentQuoteFile (filename)
                            if (this.state.currentQuoteId) {
                                await apiClient.renameEstimate(this.state.currentQuoteId, newFilename);
                            }
                        } catch (renameErr) {
                            // Если файл не найден (например, старое имя из localStorage), просто игнорируем
                            console.warn('Could not rename file, will create new:', renameErr.message);
                            // Сбрасываем старое имя
                            this.state.currentQuoteFile = null;
                        }
                    }

                    // Простое сохранение в estimates таблицу (по ID, не по filename)
                    await apiClient.saveEstimate(this.state.currentQuoteId, quoteData);

                    apiClient.setCurrentFilename(newFilename);
                    this.state.currentQuoteFile = newFilename;
                    this.state.isQuoteSaved = true;
                    this.updateQuoteStatusBar();

                    // ✅ Сохраняем ID последней открытой/созданной сметы для восстановления
                    if (this.state.currentQuoteId) {
                        localStorage.setItem('lastOpenedEstimateId', this.state.currentQuoteId);
                        console.log('[Tracking] Estimate saved, ID tracked:', this.state.currentQuoteId);
                    }

                    // 🆕 Group 3: тихое сохранение по умолчанию (по запросу пользователя).
                    //   "Все сохранения тихие без участия пользователя" — статус показывается
                    //   через updateQuoteStatusBar (зелёный кружок «●» в шапке) выше.
                    //   Уведомление-toast показываем ТОЛЬКО если caller явно попросил.
                    if (showNotification === true) {
                        this.showNotification(_t('bootstrap.quote.saved', 'Смета сохранена') + ': ' + newFilename, false);
                    }

                    return newFilename;
                } catch (err) {
                    console.error('Error saving quote:', err);
                    // Ошибки всегда показываем
                    this.showNotification(_t('bootstrap.quote.save_failed', 'Ошибка сохранения сметы') + ': ' + err.message, true);
                }
            };

            // Автосохранение сметы
            QuoteCalc.autoSaveQuote = async function() {
                // ВАЖНО: Не автосохраняем во время загрузки сметы
                if (this.isLoadingQuote) {
                    return;
                }

                // Если смета ещё не имеет ID, создаём его автоматически
                if (!this.state.currentQuoteId) {
                    this.state.currentQuoteId = this.generateQuoteId();
                    console.log('Auto-generated quote ID:', this.state.currentQuoteId);
                }

                // Получаем актуальные значения из DOM
                const programDescField = document.getElementById('program-description');
                const quoteCommentsField = document.getElementById('quote-description');

                // Обновляем state перед автосохранением
                if (programDescField) this.state.programDescription = programDescField.value;
                if (quoteCommentsField) this.state.quoteComments = quoteCommentsField.value;

                // Проверяем изменилось ли имя файла (например, добавили ФИО или изменили даты)
                const newFilenameWithJson = this.generateFilenameWithId({
                    id: this.state.currentQuoteId,
                    clientName: this.state.clientName,
                    tourStart: this.state.tourStart,
                    paxCount: this.state.paxCount
                });

                // ✅ FIX: Убираем .json расширение для новой БД (filename БЕЗ расширения)
                const newFilename = newFilenameWithJson.replace(/\.json$/i, '');

                // Если файла ещё нет - устанавливаем новое имя
                if (!this.state.currentQuoteFile) {
                    this.state.currentQuoteFile = newFilename;
                    this.updateQuoteStatusBar();
                }
                // Если имя изменилось - переименовываем файл
                else if (this.state.currentQuoteFile !== newFilename) {
                    try {
                        // ✅ FIX: Используем currentQuoteId (UUID), а не currentQuoteFile
                        if (this.state.currentQuoteId) {
                            await apiClient.renameEstimate(this.state.currentQuoteId, newFilename);
                            this.state.currentQuoteFile = newFilename;
                            this.updateQuoteStatusBar();
                        }
                    } catch (err) {
                        console.error('Error renaming during autosave:', err);
                    }
                }

                const quoteData = {
                    id: this.state.currentQuoteId,  // Добавляем ID
                    version: this.QUOTE_VERSION,
                    timestamp: new Date().toISOString(),
                    clientId: this.state.clientId || null,
                    tourName: this.state.tourName || null,
                    clientName: this.state.clientName,
                    clientPhone: this.state.clientPhone,
                    clientEmail: this.state.clientEmail,
                    paxCount: this.state.paxCount,
                    tourStart: this.state.tourStart,
                    tourEnd: this.state.tourEnd,
                    services: this.state.services,
                    hotels: this.state.hotels || [],
                    flights: this.state.flights || [],
                    otherServices: this.state.otherServices || [],
                    hiddenMarkup: this.state.hiddenMarkup,
                    taxRate: this.state.taxRate,
                    programDescription: this.state.programDescription,
                    quoteComments: this.state.quoteComments
                };

                // Guard: не автосохраняем пустую смету (возникает при навигации
                // на Settings → currencies-updated → updateCalculations → autoSave)
                const hasContent = Boolean(
                    (quoteData.clientName && quoteData.clientName.trim()) ||
                    (quoteData.tourName && quoteData.tourName.trim()) ||
                    (quoteData.services && quoteData.services.length > 0) ||
                    (quoteData.hotels && quoteData.hotels.length > 0) ||
                    (quoteData.flights && quoteData.flights.length > 0) ||
                    (quoteData.otherServices && quoteData.otherServices.length > 0)
                );
                if (!hasContent) {
                    return;
                }

                // Автосохраняем в текущий файл сметы (тихое сохранение, без уведомлений)
                apiClient.scheduleAutosave(quoteData, this.state.currentQuoteFile);
            };

            // Загрузка сметы с сервера.
            //
            // Race-protection (Sprint 11 refactor):
            //  1. Cancel pending autosave timer ДО изменения state — иначе debounced
            //     callback мог сработать после `this.isLoadingQuote = false` ниже
            //     и перезаписать только что загруженные данные.
            //  2. try/finally гарантирует reset isLoadingQuote даже при exception
            //     посередине render-цепочки (раньше flag оставался true и autosave
            //     блокировался до перезагрузки страницы).
            QuoteCalc.loadQuoteFromServer = async function(filename) {
                // (1) Cancel pending autosave (до setting флага и до load).
                if (this.timeoutIds && this.timeoutIds.autosave) {
                    clearTimeout(this.timeoutIds.autosave);
                    this.timeoutIds.autosave = null;
                }

                // (2) Ставим флаг ДО async-операции — никаких autosave до finally.
                this.isLoadingQuote = true;

                try {
                    const data = await apiClient.loadEstimate(filename);
                    if (data) {

                        // 🔧 FIX (P0): backward-compat — старые autosave-записи могли быть в nested-формате
                        //   с metadata-объектом. Читаем flat поля с фолбэком на metadata.*
                        const meta = data.metadata || {};

                        // Загружаем данные в state
                        this.state.clientId = data.clientId ?? meta.clientId ?? null;     // Sprint 18
                        this.state.tourName = data.tourName ?? meta.tourName ?? '';       // Sprint 18
                        this.state.clientName = data.clientName ?? meta.clientName ?? '';
                        this.state.clientPhone = data.clientPhone ?? meta.clientPhone ?? '';
                        this.state.clientEmail = data.clientEmail ?? meta.clientEmail ?? '';
                        this.state.paxCount = data.paxCount ?? meta.paxCount ?? 27;
                        this.state.tourStart = data.tourStart ?? meta.tourStart ?? '';
                        this.state.tourEnd = data.tourEnd ?? meta.tourEnd ?? '';
                        this.state.services = data.services || [];
                        // ВАЖНО: Загружаем новые массивы или пустые массивы (НЕ старые значения!)
                        this.state.hotels = data.hotels || [];
                        this.state.flights = data.flights || [];
                        this.state.otherServices = data.otherServices || [];
                        this.state.optionalServices = data.optionalServices || [];
                        this.state.hiddenMarkup = data.hiddenMarkup ?? meta.hiddenMarkup ?? 0;
                        this.state.partnerCommission = data.partnerCommission ?? meta.partnerCommission ?? 0;
                        this.state.taxRate = data.taxRate ?? meta.taxRate ?? 0;
                        // Sprint 19a: prepayment + approvals
                        this.state.prepaymentManual = data.prepaymentManual ?? meta.prepaymentManual ?? 0;
                        this.state.prepaymentApprovedAt = data.prepaymentApprovedAt ?? null;
                        this.state.prepaymentApprovedBy = data.prepaymentApprovedBy ?? null;
                        this.state.finalPaymentApprovedAt = data.finalPaymentApprovedAt ?? null;
                        this.state.finalPaymentApprovedBy = data.finalPaymentApprovedBy ?? null;
                        // Phase 8c: multi-currency — клиентская валюта (default 'USD' для legacy смет)
                        this.state.clientCurrency = data.clientCurrency ?? meta.clientCurrency ?? 'USD';
                        // Обновляем UI селект (если он уже отрендерён)
                        const clientCurSelect = document.getElementById('client-currency-select');
                        if (clientCurSelect) clientCurSelect.value = this.state.clientCurrency;
                        // ВАЖНО: используем ?? вместо || чтобы пустые строки не заменялись на старые значения
                        this.state.programDescription = data.programDescription ?? meta.programDescription ?? '';
                        this.state.quoteComments = data.quoteComments ?? meta.quoteComments ?? '';
                        this.state.accommodations = data.accommodations ?? meta.accommodations ?? {};
                        this.state.bookingTerms = data.bookingTerms ?? meta.bookingTerms ?? '';
                        this.state.currentQuoteFile = filename;
                        // ВАЖНО: Устанавливаем ID сметы из файла
                        this.state.currentQuoteId = data.id || '';

                        // ВАЖНО: Сначала обновляем DOM поля, ПОТОМ вызываем renderServices()
                        // Иначе автосохранение затрёт данные пустыми значениями из DOM
                        const clientNameInput = document.getElementById('client-name');
                        const clientPhoneInput = document.getElementById('client-phone');
                        const clientEmailInput = document.getElementById('client-email');
                        const paxInput = document.getElementById('pax-count');
                        const tourStartInput = document.getElementById('tour-start');
                        const tourEndInput = document.getElementById('tour-end');
                        const programDescField = document.getElementById('program-description');
                        const quoteCommentsField = document.getElementById('quote-description');

                        if (clientNameInput) clientNameInput.value = this.state.clientName;
                        if (clientPhoneInput) clientPhoneInput.value = this.state.clientPhone;
                        if (clientEmailInput) clientEmailInput.value = this.state.clientEmail;
                        if (paxInput) paxInput.value = this.state.paxCount;
                        if (tourStartInput) tourStartInput.value = this.state.tourStart;
                        if (tourEndInput) tourEndInput.value = this.state.tourEnd;
                        // Sprint 18: tour-name input + hidden client-id
                        const _tourNameInput = document.getElementById('tour-name');
                        if (_tourNameInput) _tourNameInput.value = this.state.tourName || '';
                        const _clientIdHidden = document.getElementById('client-id');
                        if (_clientIdHidden) _clientIdHidden.value = this.state.clientId || '';
                        if (programDescField) programDescField.value = this.state.programDescription;
                        if (quoteCommentsField) quoteCommentsField.value = this.state.quoteComments;

                        // Обновляем Quill редакторы если они инициализированы
                        if (this.quillEditors) {
                            if (this.quillEditors.programDescription) {
                                this.quillEditors.programDescription.root.innerHTML = this.state.programDescription || '';
                            }
                            if (this.quillEditors.quoteDescription) {
                                this.quillEditors.quoteDescription.root.innerHTML = this.state.quoteComments || '';
                            }
                            if (this.quillEditors.bookingTerms) {
                                this.quillEditors.bookingTerms.root.innerHTML = this.state.bookingTerms || '';
                            }
                        }

                        // ТЕПЕРЬ обновляем UI (это может запустить автосохранение, но мы его заблокировали)
                        this.updateCalculations();
                        this.renderServices();
                        this.renderHotels();
                        this.renderFlights();
                        this.renderOtherServices();
                        this.renderServicesDetailList();

                        // (autosave включается в finally ниже — гарантия reset
                        // даже при exception в render-цепочке)

                        // ✅ Сохраняем ID последней открытой сметы для восстановления при перезагрузке
                        if (data.id) {
                            localStorage.setItem('lastOpenedEstimateId', data.id);
                            console.log('[Tracking] Last opened estimate ID saved:', data.id);
                        }

                        // Estimate Lifecycle Status Bar (Sprint 19)
                        const statusBarContainer = document.getElementById('estimate-lifecycle-bar-container');
                        if (statusBarContainer && window.EstimateStatusBar) {
                            const estimateId = data.id || this.state.currentQuoteId;
                            const renderLifecycleBar = (statusData) => {
                                statusBarContainer.innerHTML = '';
                                statusBarContainer.style.display = '';
                                const bar = window.EstimateStatusBar.render(statusData);
                                statusBarContainer.appendChild(bar);
                                window.EstimateStatusBar.bind(estimateId, apiClient, (result) => {
                                    renderLifecycleBar({
                                        status: result.to_status,
                                        allowedTransitions: result.allowedTransitions || [],
                                        nextStatus: result.nextStatus || null,
                                        prepaymentApprovedAt: this.state.prepaymentApprovedAt
                                    });
                                });
                            };
                            renderLifecycleBar({
                                status: data.status || 'draft',
                                allowedTransitions: data.allowedTransitions || [],
                                nextStatus: data.nextStatus || null,
                                prepaymentApprovedAt: data.prepaymentApprovedAt,
                                bookingsCompleteAt: data.bookingsCompleteAt,
                                tourStartedAt: data.tourStartedAt,
                                tourEndedAt: data.tourEndedAt,
                                suppliersPaidAt: data.suppliersPaidAt,
                                reconciliationDoneAt: data.reconciliationDoneAt
                            });
                        }

                        // Обновляем статус-бар с именем файла
                        this.state.isQuoteSaved = true;
                        this.updateQuoteStatusBar();

                        this.showNotification(_t('bootstrap.quote.loaded', 'Смета загружена') + ': ' + filename, false);
                    }
                } catch (err) {
                    console.error('Error loading quote:', err);
                    this.showNotification(_t('bootstrap.quote.load_failed', 'Ошибка загрузки сметы') + ': ' + err.message, true);
                } finally {
                    // Гарантированно reset флага, даже если render бросил.
                    this.isLoadingQuote = false;
                }
            };

            // Перехватываем изменения для автосохранения
            const originalUpdateCalculations = QuoteCalc.updateCalculations.bind(QuoteCalc);
            QuoteCalc.updateCalculations = function() {
                originalUpdateCalculations();
                this.autoSaveQuote();
            };

            // ПЕРЕОПРЕДЕЛЯЕМ методы работы с файлами на серверные

            // Сохранить каталог (заменяем File API на server API)
            QuoteCalc.saveCatalogJSON = async function() {
                await this.saveCatalogToServer();
            };

            // Загрузить каталог (заменяем File API на server API)
            QuoteCalc.loadCatalogJSON = async function(event) {
                // Если есть event (загрузка файла вручную), обрабатываем как раньше
                if (event && event.target && event.target.files && event.target.files[0]) {
                    const file = event.target.files[0];
                    try {
                        const text = await file.text();
                        const jsonData = JSON.parse(text);

                        if (jsonData.templates) {
                            this.templates = jsonData.templates;
                            this.categories = jsonData.categories || [];
                            this.currentRegion = jsonData.region || 'Default';

                            // Сохраняем загруженный каталог на сервер
                            await this.saveCatalogToServer();

                            this.saveToLocalStorage();
                            this.renderTemplates();
                            this.showNotification(_t('bootstrap.catalog.loaded_and_saved', 'Каталог загружен и сохранён на сервере'), false);
                        }
                    } catch (err) {
                        console.error('Error loading catalog:', err);
                        this.showNotification(_t('bootstrap.catalog.load_failed', 'Ошибка загрузки каталога') + ': ' + err.message, true);
                    }
                } else {
                    // Загружаем с сервера
                    await this.loadCatalogFromServer();
                }
            };

            // Сохранить смету БЕЗ prompt - тихое сохранение на сервер
            QuoteCalc.saveQuoteJSON = async function() {
                // Если смета уже открыта - сохраняем в тот же файл
                if (this.state.currentQuoteFile) {
                    await this.saveQuoteToServer(this.state.currentQuoteFile);
                    this.showNotification(_t('bootstrap.quote.saved_to_server', 'Смета сохранена на сервере'), false);
                } else {
                    // Для новой сметы - генерируем имя автоматически с транслитерацией
                    const filename = this.generateFilename();
                    await this.saveQuoteToServer(filename);
                    this.showNotification(`${_t('bootstrap.quote.saved', 'Смета сохранена')}: ${filename}`, false);
                }
            };

            // Скачать бэкап локально (не меняет текущую смету на сервере)
            QuoteCalc.downloadBackup = function() {
                try {
                    // Получаем актуальные значения из DOM
                    const programDescField = document.getElementById('program-description');
                    const quoteCommentsField = document.getElementById('quote-description');

                    if (programDescField) this.state.programDescription = programDescField.value;
                    if (quoteCommentsField) this.state.quoteComments = quoteCommentsField.value;

                    // Формируем данные для скачивания
                    const data = {
                        version: this.QUOTE_VERSION,
                        timestamp: new Date().toISOString(),
                        clientId: this.state.clientId || null,
                        tourName: this.state.tourName || null,
                        clientName: this.state.clientName,
                        clientPhone: this.state.clientPhone,
                        clientEmail: this.state.clientEmail,
                        paxCount: this.state.paxCount,
                        services: this.state.services,
                        hotels: this.state.hotels || [],
                        flights: this.state.flights || [],
                        otherServices: this.state.otherServices || [],
                        hiddenMarkup: this.state.hiddenMarkup,
                        taxRate: this.state.taxRate,
                        programDescription: this.state.programDescription,
                        quoteComments: this.state.quoteComments
                    };

                    // Генерируем имя файла для бэкапа
                    const filename = this.state.currentQuoteFile ||
                        `${this.state.clientName || 'quote'}_${new Date().toISOString().split('T')[0]}_${this.state.paxCount}pax.json`;

                    // Создаём blob и скачиваем
                    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);

                    this.showNotification(`${_t('bootstrap.backup.downloaded', 'Бэкап скачан')}: ${filename}`, false);
                } catch (error) {
                    this.showNotification(_t('bootstrap.backup.download_failed', 'Ошибка скачивания бэкапа') + ': ' + error.message, true);
                }
            };

            // Загрузить смету (заменяем File API на server API)
            QuoteCalc.loadQuoteJSON = async function(event) {
                // Если есть event (загрузка файла вручную), обрабатываем как раньше
                if (event && event.target && event.target.files && event.target.files[0]) {
                    const file = event.target.files[0];
                    try {
                        const text = await file.text();
                        const jsonData = JSON.parse(text);

                        // ВАЖНО: Сначала очищаем textarea поля чтобы избежать "прилипания"
                        const programDescField = document.getElementById('program-description');
                        const quoteCommentsField = document.getElementById('quote-description');
                        if (programDescField) programDescField.value = '';
                        if (quoteCommentsField) quoteCommentsField.value = '';

                        // ✅ FIX: При импорте ВСЕГДА создаём НОВЫЙ ID (чтобы избежать UNIQUE constraint)
                        this.state.currentQuoteId = this.generateQuoteId();

                        this.state.clientName = jsonData.clientName || '';
                        this.state.clientPhone = jsonData.clientPhone || '';
                        this.state.clientEmail = jsonData.clientEmail || '';
                        this.state.paxCount = jsonData.paxCount || 27;
                        this.state.tourStart = jsonData.tourStart || '';
                        this.state.tourEnd = jsonData.tourEnd || '';
                        this.state.services = jsonData.services || [];
                        this.state.hotels = jsonData.hotels || [];
                        this.state.flights = jsonData.flights || [];
                        this.state.otherServices = jsonData.otherServices || [];
                        this.state.hiddenMarkup = jsonData.hiddenMarkup || 0;
                        this.state.taxRate = jsonData.taxRate || 0;
                        // ВАЖНО: используем ?? вместо || чтобы пустые строки не заменялись на старые значения
                        this.state.programDescription = jsonData.programDescription ?? '';
                        this.state.quoteComments = jsonData.quoteComments ?? '';

                        // Сохраняем загруженную смету на сервер с автоматически сгенерированным именем
                        const filename = this.generateFilename();
                        await this.saveQuoteToServer(filename);

                        // Обновляем UI
                        this.updateCalculations();
                        this.renderServices();
                        this.renderServicesDetailList();

                        // Обновляем поля клиента в DOM (programDescField уже объявлен выше на строке 9297)
                        const clientNameInput = document.getElementById('client-name');
                        const clientPhoneInput = document.getElementById('client-phone');
                        const clientEmailInput = document.getElementById('client-email');
                        const paxInput = document.getElementById('pax-count');
                        const tourStartInput = document.getElementById('tour-start');
                        const tourEndInput = document.getElementById('tour-end');
                        // programDescField и quoteCommentsField уже объявлены в начале функции

                        if (clientNameInput) clientNameInput.value = this.state.clientName;
                        if (clientPhoneInput) clientPhoneInput.value = this.state.clientPhone;
                        if (clientEmailInput) clientEmailInput.value = this.state.clientEmail;
                        if (paxInput) paxInput.value = this.state.paxCount;
                        if (tourStartInput) tourStartInput.value = this.state.tourStart;
                        if (tourEndInput) tourEndInput.value = this.state.tourEnd;
                        // Sprint 18: tour-name input + hidden client-id
                        const _tourNameInput = document.getElementById('tour-name');
                        if (_tourNameInput) _tourNameInput.value = this.state.tourName || '';
                        const _clientIdHidden = document.getElementById('client-id');
                        if (_clientIdHidden) _clientIdHidden.value = this.state.clientId || '';
                        if (programDescField) programDescField.value = this.state.programDescription;
                        if (quoteCommentsField) quoteCommentsField.value = this.state.quoteComments;


                        // Обновляем статус-бар с именем файла
                        this.state.isQuoteSaved = true;
                        this.updateQuoteStatusBar();

                        this.showNotification(_t('bootstrap.quote.imported_saved', 'Смета загружена и сохранена на сервере') + ': ' + filename, false);
                    } catch (err) {
                        console.error('Error loading quote:', err);
                        this.showNotification(_t('bootstrap.quote.load_failed', 'Ошибка загрузки сметы') + ': ' + err.message, true);
                    }
                } else {
                    // Показываем список смет с сервера
                    await window.showEstimatesList();
                }
            };

            // Загрузка каталога при старте
            QuoteCalc.init = async function() {
                originalInit();
                // Попытка загрузить каталог с сервера
                try {
                    await this.loadCatalogFromServer();
                } catch (err) {
                    console.log('Using local catalog');
                }
            };
        })();

        // ===== Оборачиваем критические методы с ErrorBoundary =====
        (function() {
            // Сохраняем оригинальные методы
            const originalLoadQuote = QuoteCalc.loadQuoteFromServer;
            const originalSaveQuote = QuoteCalc.saveQuoteToServer;
            const originalUpdateCalc = QuoteCalc.updateCalculations;

            // Оборачиваем loadQuoteFromServer
            if (originalLoadQuote) {
                QuoteCalc.loadQuoteFromServer = errorBoundary.wrapAsync(
                    originalLoadQuote.bind(QuoteCalc),
                    'load'
                );
                console.log('[ErrorBoundary] Wrapped loadQuoteFromServer');
            }

            // Оборачиваем saveQuoteToServer
            if (originalSaveQuote) {
                QuoteCalc.saveQuoteToServer = errorBoundary.wrapAsync(
                    originalSaveQuote.bind(QuoteCalc),
                    'save'
                );
                console.log('[ErrorBoundary] Wrapped saveQuoteToServer');
            }

            // Оборачиваем updateCalculations (синхронная, поэтому обертка для sync)
            if (originalUpdateCalc) {
                QuoteCalc.updateCalculations = function() {
                    try {
                        return originalUpdateCalc.call(this);
                    } catch (err) {
                        const snapshot = errorBoundary.captureSnapshot();
                        errorBoundary.logError('calculations', err, snapshot, 0);
                        errorBoundary.showNotification('calculations', err);
                        errorBoundary.tryRecover('calculations', err, snapshot);
                        throw err;
                    }
                };
                console.log('[ErrorBoundary] Wrapped updateCalculations');
            }
        })();

        // Глобальные функции для работы со сметами (ДОЛЖНЫ БЫТЬ ВНЕ IIFE!)
        // Показать список смет
        window.showEstimatesList = async function() {
            try {
                const estimates = await apiClient.getEstimatesList();
                const modal = document.getElementById('estimates-modal');
                const listContainer = document.getElementById('estimates-list');

                const emptyMsg = _t('bootstrap.estimates_list.empty', 'Нет сохранённых смет');
                const unnamed = _t('bootstrap.estimates_list.unnamed', 'Без имени');
                const paxLabel = _t('bootstrap.estimates_list.pax', 'PAX');
                const openLabel = _t('btn.open', 'Открыть');
                const deleteLabel = _t('btn.delete', 'Удалить');
                const loc = (window.i18n && window.i18n.getLocale && window.i18n.getLocale()) || 'ru-RU';
                if (estimates.length === 0) {
                    listContainer.innerHTML = `<p style="text-align: center; color: var(--gray-500);">${emptyMsg}</p>`;
                } else {
                    listContainer.innerHTML = estimates.map(est => `
                        <div style="border: 1px solid var(--gray-200); border-radius: 6px; padding: 12px; margin-bottom: 8px; display: flex; justify-content: space-between; align-items: center;">
                            <div style="flex: 1;">
                                <div style="font-weight: 600; margin-bottom: 4px;">${est.clientName || unnamed}</div>
                                <div style="font-size: 12px; color: var(--gray-600);">
                                    ${paxLabel}: ${est.paxCount || 0} | ${new Date(est.updatedAt).toLocaleString(loc)}
                                </div>
                                <div style="font-size: 10px; color: var(--gray-400); margin-top: 2px;">${est.filename}</div>
                            </div>
                            <div style="display: flex; gap: 8px;">
                                <button onclick="loadEstimate('${est.id}')" style="padding: 6px 12px; background: var(--primary); color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px;">${openLabel}</button>
                                <button onclick="deleteEstimate('${est.id}')" style="padding: 6px 12px; background: var(--warning); color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px;">${deleteLabel}</button>
                            </div>
                        </div>
                    `).join('');
                }

                modal.style.display = 'flex';
            } catch (err) {
                console.error('Error loading estimates list:', err);
                window.QuoteCalc.showNotification(_t('bootstrap.estimates_list.load_failed', 'Ошибка загрузки списка смет') + ': ' + err.message, true);
            }
        };

        // 🆕 Backups v2: показать список бэкапов (вкладка «Автосохранения»)
        window.showBackupsList = async function() {
            try {
                const listContainer = document.getElementById('backups-list');
                if (!listContainer) return;
                listContainer.innerHTML = `<p style="text-align: center; color: var(--gray-500); padding: 16px;">${_t('common.loading', 'Загрузка...')}</p>`;

                const result = await apiClient.listBackups({ limit: 100 });
                const backups = result.backups || [];

                if (backups.length === 0) {
                    listContainer.innerHTML = `<p style="text-align: center; color: var(--gray-500); padding: 16px;">${_t('bootstrap.backups_list.empty', 'Нет автосохранений. Бэкапы создаются автоматически в процессе работы со сметой.')}</p>`;
                    return;
                }

                // Группируем по estimate_id для удобного просмотра
                const byEstimate = {};
                for (const b of backups) {
                    if (!byEstimate[b.estimate_id]) byEstimate[b.estimate_id] = [];
                    byEstimate[b.estimate_id].push(b);
                }

                const unnamedShort = _t('bootstrap.backups_list.unnamed', '(без имени)');
                const deletedTag = _t('bootstrap.backups_list.estimate_deleted', 'Смета удалена');
                const paxShort = _t('bootstrap.backups_list.pax_short', 'Pax');
                const backupsCount = _t('bootstrap.backups_list.count', 'бэкапов');
                const showAllTpl = _t('bootstrap.backups_list.show_all', 'Показать все бэкапы');
                const restoreLabel = _t('btn.restore', 'Восстановить');
                const deleteLabel = _t('btn.delete', 'Удалить');
                const loc = (window.i18n && window.i18n.getLocale && window.i18n.getLocale()) || 'ru-RU';
                listContainer.innerHTML = Object.entries(byEstimate).map(([eid, group]) => {
                    const newest = group[0]; // sorted DESC by created_at
                    const orphan = newest.is_orphan;
                    const clientLabel = newest.estimate_client_name || unnamedShort;
                    return `
                        <div style="border: 1px solid var(--gray-200); border-radius: 6px; padding: 12px; margin-bottom: 12px; ${orphan ? 'background: #fef3c7;' : ''}">
                            <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 8px;">
                                <div style="flex: 1;">
                                    <div style="font-weight: 600; font-size: 14px;">
                                        ${clientLabel}
                                        ${orphan ? `<span style="color: #92400e; font-size: 10px; margin-left: 8px;">⚠️ ${deletedTag}</span>` : ''}
                                    </div>
                                    <div style="font-size: 11px; color: var(--gray-600); margin-top: 2px;">
                                        ${paxShort}: ${newest.estimate_pax_count || 0}
                                        ${newest.estimate_tour_start ? '| ' + newest.estimate_tour_start : ''}
                                        | ${backupsCount}: ${group.length}
                                    </div>
                                </div>
                            </div>
                            <details style="margin-top: 6px;">
                                <summary style="cursor: pointer; font-size: 11px; color: var(--gray-700);">${showAllTpl} (${group.length})</summary>
                                <div style="margin-top: 8px;">
                                    ${group.map(b => `
                                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 6px 0; border-top: 1px solid var(--gray-100);">
                                            <div style="font-size: 11px; flex: 1;">
                                                <span style="color: var(--gray-600);">${new Date(b.created_at * 1000).toLocaleString(loc)}</span>
                                                <span style="color: var(--gray-400); margin-left: 6px;">[${b.backup_reason}]</span>
                                            </div>
                                            <div style="display: flex; gap: 4px;">
                                                <button onclick="window.restoreBackup('${b.id}')" style="padding: 3px 8px; background: var(--primary); color: white; border: none; border-radius: 3px; cursor: pointer; font-size: 10px;">${restoreLabel}</button>
                                                <button onclick="window.deleteBackup('${b.id}')" style="padding: 3px 8px; background: var(--warning); color: white; border: none; border-radius: 3px; cursor: pointer; font-size: 10px;">${deleteLabel}</button>
                                            </div>
                                        </div>
                                    `).join('')}
                                </div>
                            </details>
                        </div>
                    `;
                }).join('');
            } catch (err) {
                console.error('Error loading backups list:', err);
                const listContainer = document.getElementById('backups-list');
                if (listContainer) {
                    listContainer.innerHTML = `<p style="color: var(--warning); padding: 16px;">${_t('bootstrap.backups_list.load_failed', 'Ошибка загрузки')}: ${err.message}</p>`;
                }
            }
        };

        window.restoreBackup = async function(backupId) {
            if (!confirm(_t('bootstrap.backup.restore_confirm', 'Восстановить смету из этого бэкапа? Текущие несохранённые изменения будут потеряны.'))) return;
            try {
                const result = await apiClient.restoreBackup(backupId);
                document.getElementById('estimates-modal').style.display = 'none';
                await window.QuoteCalc.loadQuoteFromServer(result.estimate_id);
                window.QuoteCalc.showNotification(_t('bootstrap.backup.restored', 'Смета восстановлена из бэкапа'), false);
            } catch (err) {
                window.QuoteCalc.showNotification(_t('bootstrap.backup.restore_failed', 'Ошибка восстановления') + ': ' + err.message, true);
            }
        };

        window.deleteBackup = async function(backupId) {
            if (!confirm(_t('bootstrap.backup.delete_confirm', 'Удалить этот бэкап? Действие необратимо.'))) return;
            try {
                await apiClient.deleteBackup(backupId);
                window.showBackupsList(); // refresh
            } catch (err) {
                window.QuoteCalc.showNotification(_t('bootstrap.backup.delete_failed', 'Ошибка удаления') + ': ' + err.message, true);
            }
        };

        // Загрузить смету из списка (ID-First Pattern)
        window.loadEstimate = async function(id) {
            document.getElementById('estimates-modal').style.display = 'none';
            await window.QuoteCalc.loadQuoteFromServer(id);
        };

        // Удалить смету (ID-First Pattern)
        window.deleteEstimate = async function(id) {
            if (!confirm(_t('bootstrap.estimate.delete_confirm', 'Удалить эту смету?'))) {
                return;
            }
            try {
                await apiClient.deleteEstimate(id);
                window.QuoteCalc.showNotification(_t('bootstrap.estimate.deleted', 'Смета удалена'), false);
                window.showEstimatesList(); // Обновить список
            } catch (err) {
                console.error('Error deleting estimate:', err);
                window.QuoteCalc.showNotification(_t('bootstrap.estimate.delete_failed', 'Ошибка удаления сметы') + ': ' + err.message, true);
            }
        };

        // Функция импорта файла
        window.importQuoteFile = async function(file) {
            try {
                const reader = new FileReader();
                reader.onload = async function(e) {
                    try {
                        let rawData = JSON.parse(e.target.result);
                        let data = {};

                        // Поддержка формата v1.1.0+ с metadata объектом
                        if (rawData.metadata) {
                            // Новый формат: metadata содержит основные поля
                            data = {
                                id: rawData.id || window.QuoteCalc.generateQuoteId(),
                                clientName: rawData.metadata.clientName || '',
                                clientPhone: rawData.metadata.clientPhone || '',
                                clientEmail: rawData.metadata.clientEmail || '',
                                paxCount: rawData.metadata.paxCount || 27,
                                tourStart: rawData.metadata.tourStart || '',
                                tourEnd: rawData.metadata.tourEnd || '',
                                // Миграция: quoteDescription → quoteComments
                                quoteComments: rawData.metadata.quoteComments || rawData.metadata.quoteDescription || '',
                                programDescription: rawData.metadata.programDescription || '',
                                hiddenMarkup: rawData.metadata.hiddenMarkup || 0,
                                partnerCommission: rawData.metadata.partnerCommission || 0,
                                taxRate: rawData.metadata.taxRate || 0,
                                services: rawData.services || [],
                                version: rawData.version || '1.1.0',
                                appVersion: rawData.appVersion || '2.2.0'
                            };
                        } else {
                            // Старый формат: поля на верхнем уровне
                            data = {
                                id: rawData.id || window.QuoteCalc.generateQuoteId(),
                                clientName: rawData.clientName || '',
                                clientPhone: rawData.clientPhone || '',
                                clientEmail: rawData.clientEmail || '',
                                paxCount: rawData.paxCount || 27,
                                tourStart: rawData.tourStart || '',
                                tourEnd: rawData.tourEnd || '',
                                // Миграция: quoteDescription → quoteComments
                                quoteComments: rawData.quoteComments || rawData.quoteDescription || '',
                                programDescription: rawData.programDescription || '',
                                hiddenMarkup: rawData.hiddenMarkup || 0,
                                partnerCommission: rawData.partnerCommission || 0,
                                taxRate: rawData.taxRate || 0,
                                services: rawData.services || [],
                                version: rawData.version || '1.0.0',
                                appVersion: rawData.appVersion || '2.1.0'
                            };
                        }

                        // Генерируем имя файла
                        const filename = window.QuoteCalc.generateFilenameWithId(data);

                        // ID-First: сохранение по ID
                        await apiClient.saveEstimate(data.id, data);

                        // Закрываем модальное окно и загружаем импортированную смету
                        document.getElementById('estimates-modal').style.display = 'none';
                        await window.QuoteCalc.loadQuoteFromServer(data.id);
                        window.QuoteCalc.showNotification(_t('bootstrap.import.imported', 'Смета импортирована') + ': ' + filename, false);
                    } catch (err) {
                        console.error('Error parsing JSON:', err);
                        window.QuoteCalc.showNotification(_t('bootstrap.import.parse_failed', 'Ошибка чтения файла') + ': ' + err.message, true);
                    }
                };
                reader.readAsText(file);
            } catch (err) {
                console.error('Error importing file:', err);
                window.QuoteCalc.showNotification(_t('bootstrap.import.failed', 'Ошибка импорта') + ': ' + err.message, true);
            }
        };

        // Оборачиваем импорт с ErrorBoundary
        (function() {
            const originalImport = window.importQuoteFile;
            if (originalImport) {
                window.importQuoteFile = errorBoundary.wrapAsync(
                    originalImport,
                    'import'
                );
                console.log('[ErrorBoundary] Wrapped importQuoteFile');
            }
        })();

        // Инициализация серверной интеграции
        // ВАЖНО: Код уже внутри window.addEventListener('load'), поэтому DOM точно загружен
        // Обработчики модального окна
            const closeBtn = document.getElementById('close-estimates-modal');
            const modal = document.getElementById('estimates-modal');

            if (closeBtn) {
                closeBtn.addEventListener('click', function() {
                    modal.style.display = 'none';
                });
            }

            if (modal) {
                // Закрытие по клику вне модального окна
                modal.addEventListener('click', function(e) {
                    if (e.target === this) {
                        this.style.display = 'none';
                    }
                });
            }

            // Обработчики переключения вкладок
            const tabs = ['estimates', 'backups', 'import'];
            tabs.forEach(tabName => {
                const tabBtn = document.getElementById(`tab-${tabName}`);
                if (tabBtn) {
                    tabBtn.addEventListener('click', function() {
                        // Убираем активный класс со всех вкладок
                        document.querySelectorAll('.modal-tab').forEach(t => t.classList.remove('active'));
                        // Скрываем весь контент
                        document.querySelectorAll('.tab-content').forEach(c => c.style.display = 'none');

                        // Активируем текущую вкладку
                        this.classList.add('active');
                        document.getElementById(`content-${tabName}`).style.display = 'block';

                        // Загружаем данные для вкладки
                        if (tabName === 'estimates') {
                            window.showEstimatesList();
                        } else if (tabName === 'backups') {
                            window.showBackupsList();
                        }
                    });
                }
            });

            // Обработчик кнопки импорта
            const importBtn = document.getElementById('import-file-btn');
            const importInput = document.getElementById('import-file-input');

            if (importBtn && importInput) {
                importBtn.addEventListener('click', function() {
                    importInput.click();
                });

                importInput.addEventListener('change', function(e) {
                    const file = e.target.files[0];
                    if (file) {
                        window.importQuoteFile(file);
                    }
                    // Сбрасываем input чтобы можно было импортировать тот же файл снова
                    e.target.value = '';
                });
            }

        // Серверная интеграция успешно активирована
        // Глобальные функции определены и доступны
        console.log('[Init] All systems initialized');
        }); // конец window.addEventListener('load')
